import React from 'react'
import { useNavigate } from 'react-router-dom'

import styles from './index.module.less'
import RelateTagList from '../../../components/RelateTagList'
import AutoImage from '../../../components/AutoImage'
import { formatJSON, renderImageUrl } from '../../../utils'

import { addBehaviorsRecord } from '../../../utils/BehaviorstatsHelp'
import defaultImg from '../../../assets/images/def_img_food.png'
import PriceText from '../../../components/ProductMenu/PriceText'
import ProductOriPrice from '../../../components/ProductOriPrice'
export default function RestaurantCard({ list = [], title = '', areaId }) {
    const navigate = useNavigate()
    const renderProduct = (products, merchant) => {
        const { productImages, logo } = merchant
        const img = productImages || logo || defaultImg

        return <div className={styles.rlSpaProducts}>
            {products.map((product, index) => (
                <div key={index} className={styles.productItem}
                    onClick={() => {
                        navigate(`/relate-product?productId=${product.productId}`)
                        addBehaviorsRecord({
                            behaviorType: 160200,
                            behavior: 160206,
                            storeId: merchant.storeId,
                            value1: product.productId,
                            value2: 'recommend'
                        })
                    }}>
                    <div style={{ fontSize: 0 }}>
                        <AutoImage src={product.images || img} alt="product-image" onError={(e) => { e.target.src = img }} />
                    </div>
                    <div className={styles.productInfo}>
                        <div className={`${styles.productName} ellips_line2`} style={{ height: 44 }}>{product.name}</div>
                        <div className={`${styles.productTag} scroll-x`} style={{ height: 31 }}>
                            {product.tagRelates && product.tagRelates.length > 0 && <RelateTagList list={product.tagRelates} wrap={false} />}
                        </div>
                        <div className={`${styles.productPrice} jm-price fs-16`}>
                            <PriceText product={product} />
                            <ProductOriPrice item={product} />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    }

    const renderBackgroundImage = (item) => {
        const { image } = item
        return `url(${renderImageUrl({ size: 'b', src: image })})`
    }
    return (
        <div className={styles.spaCard}>
            <div className={styles.spaTitle}>{title}</div>
            <div className={styles.spaBody}>
                {
                    list.map((item, index) => (
                        <div key={index}
                            className={styles.spaItemBox}
                            onClick={() => {
                                let text = `areaid=${areaId}&partnerid=${item.partnerId}&hotel=${item.shortName || item.name}&storeid=${item.storeId}`
                                navigate(`/spa?${text}`)

                                addBehaviorsRecord({
                                    behaviorType: 160200,
                                    behavior: 160205,
                                    storeId: item.storeId,
                                })
                            }}>
                            <div className={styles.spaItem}
                                style={{
                                    backgroundImage: renderBackgroundImage(item),
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                    position: 'relative'
                                }}
                            >
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        backgroundColor: 'rgba(0,0,0,0.1)',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'flex-end'
                                    }}>
                                    <div className={styles.directBox}>&nbsp; </div>
                                    <div className={styles.cardImgBox}>&nbsp; </div>
                                    <div className={styles.spaInfo}>
                                        <div className={styles.logo}><AutoImage src={item.logo} alt="logo" /></div>
                                        <div className={`${styles.resName} ellips`}>{item.shortName || item.name}</div>
                                        <div className={`${styles.description} ellips`}> <small>{item.description}</small> </div>
                                        <div className={`${styles.mcTag} scroll-x`} style={{ height: 31 }}><RelateTagList list={item.tagRelates} wrap={false} /></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
                {
                    list.length === 1 && (renderProduct(list[0].products, list[0]))
                }
            </div>
        </div>
    )
}
